var exports = {
  "kL": "x61f99309--eeb9b1--container",
  "DP": "x61f99309--eeb9b1--container-mobile",
  "wx": "x61f99309--eeb9b1--header",
  "DD": "x61f99309--eeb9b1--title",
  "vR": "x61f99309--eeb9b1--tabs",
};

module.exports = exports;
